import { render, staticRenderFns } from "./main-form.vue?vue&type=template&id=024a8e20"
import script from "./main-form.vue?vue&type=script&lang=js"
export * from "./main-form.vue?vue&type=script&lang=js"
import style0 from "./main-form.vue?vue&type=style&index=0&id=024a8e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports